<p-autoComplete class="w-full"
[(ngModel)]="selectedUser" 
[suggestions]="filteredDropdownItems" 
[dropdown]="true" 
[forceSelection]="true"
[placeholder]="placeholder" 
(completeMethod)="search($event)"
[completeOnFocus]="true"
(onSelect)="onUserSelected($event)"
[readonly]="readonly"
(onClear)="onUserClear()"
[disabled]="disabled"
optionLabel="fullName"
inputStyleClass="w-full"
appendTo="body"
>

</p-autoComplete>
